<template>
    <div class="login-content">
        <div class="login-box">
            <h1 class="lean">产业链Login</h1>
            <van-form @submit="onSubmit">
                <van-field v-model="username" name="username" label="手机号" maxlength="11" placeholder="手机号"
                    :rules="[{ required: true, message: '请填写手机号' },{ validator:validatorPhone, message: '格式错误，请检查手机号' }]"
                    left-icon="user" label-width="48" />
                <van-field v-model="password" type="password" name="password" label="密码" placeholder="密码"
                    :rules="[{ required: true, message: '请填写密码' }]" left-icon="lock" label-width="48" autocomplete />
                <van-button type="info" block native-type="submit" style="margin-top: 20px;">登录</van-button>
                <!--                 <van-button class="login-button" type="danger" native-type="submit">
                    <van-icon name="down" style="transform: rotate(-90deg)"/>
                </van-button> -->
            </van-form>
        </div>

        <van-popup v-model="show" round :style="{ width: '80%' }">
            <h2 class="login-check">请选择登录主体</h2>
            <div style="min-height: 320px;max-height: 320px;overflow-y: scroll;">
                <van-cell v-for="item in listBranch" :key="item.orgId" :title="item.branchName" clickable
                    @click="handleCheck(item.orgId)">
                    <template #right-icon>
                        <van-icon style="transform: rotate(90deg);font-size: .4rem;" name="upgrade" color="#1989fa" size="large"/>
                    </template>
                </van-cell>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { Field,Form ,Icon ,Button,Toast,Popup,Radio,RadioGroup ,Cell } from 'vant';
import { sha256 } from 'js-sha256';
  export default {
    components:{
        [Field.name]:Field,
        [Form.name]:Form,
        [Icon.name]:Icon,
        [Button.name]:Button,
        [Popup.name]:Popup,
        [RadioGroup.name]:RadioGroup,
        [Radio.name]:Radio,
        [Cell.name]:Cell,
    },
    data(){
      return{
        username:'13688888888',
        password:'150315',
        show:false,
        listBranch:[],  //  机构
        orgID:''//  机构ID
      }
    },
    methods: {
        sha256,
        onSubmit(values) {
            console.log('submit', values);
            this.axios.post('/foundation/auth/login',
                {
                    mobile: this.username,
                    username: this.username,
                    password: this.sha256(this.password),
                    validateCode: '',
                    modify: 'N'
                }).then((response) => {
                    var data = response.data;

                    switch (response.statusCode) {
                        case '0':
                            this.listBranch=data;
                            window.localStorage.setItem('mobile', this.username);
                            
                            if(this.listBranch.length==1){
                                this.handleCheck(this.listBranch[0].orgId);
                            }else{
                                this.show=true;
                            }
                            break;
                        case 'TIPS_001'://首次登录
                            Toast.fail('首次登录，请移步至产业链管理系统修改密码');
                            break;
                        case 'TIPS_002'://密码过期
                            Toast.fail('您的登录密码已到期，请移步至产业链管理系统修改密码');
                            break;
                        default:
                            break;
                    }
                }).catch((error) => {
                    Toast.fail(error.message);
                });
        },
        handleCheck(orgid){
            const _that =this;
            this.orgID = orgid;
            this.axios.post('/foundation/auth/switchOrg',{
                    username: this.username,
                    password: this.sha256(this.password),
                    orgId: this.orgID,
                    modify: 'N'
                }).then(function(response) {
                var data = response.data;
                switch(response.statusCode) {
                    case '0':
                        //document.cookie = 'token=' + data.data.token;
                        window.localStorage.setItem('token', data.token);
                        window.$util.cookie.set('token', data.token);
                        window.localStorage.setItem('loginSubject', window.JSON.stringify(data));
                        _that.$router.push({path:'/land-home'})
                        break;
                    default:
                        Toast.fail(response.statusDesc);
                }
            }).catch(function(error) {
                Toast.fail(error.message);
            });
        },
        validatorPhone(val) {
            return /^1[3456789]\d{9}$/.test(val);
        }
    },
    created(){},
    mounted(){
        window.sessionStorage.setItem('from','WeWork');
    }
 }
</script>

<style lang=scss>
.login-content {
	overflow: hidden;
	height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
}
.login-content:before {
	height: 50%;
	width: 100%;
	position: absolute;
	top: 0;
	left: 0;
	background: #4778c7;
	content: "";
	z-index: 0
}

.login-box{
    padding:10px;
    background: #fff;
    z-index: 1;
    flex-grow: 2;
    margin:0 40px;
    box-shadow: 0 1px 11px rgba(0, 0, 0, 0.27);
	border-radius: 2px;
    position: relative;
}

h1.lean{
	color:#7E7E7E;
	text-align:center;
    font-size: .3rem;;
	line-height:2;
}
h1.lean:before,
h1.lean:after{
	content:"";
	height:1px;
	position:absolute;
	top:35px;
	width:35%;
}

h1.lean:after{
	background:rgb(126,126,126);
	background:-moz-linear-gradient(left,rgba(126,126,126,1) 0%,rgba(255,255,255,1) 100%);
	background:-webkit-linear-gradient(left,rgba(126,126,126,1) 0%,rgba(255,255,255,1) 100%);
	background:-moz-linear-gradient(left,rgba(126,126,126,1) 0%,rgba(255,255,255,1) 100%);
	background:-ms-linear-gradient(left,rgba(126,126,126,1) 0%,rgba(255,255,255,1) 100%);
	background:linear-gradient(left,rgba(126,126,126,1) 0%,rgba(255,255,255,1) 100%);
	right:0px;
}

h1.lean:before{
	background:rgb(126,126,126);
	background:-moz-linear-gradient(right,rgba(126,126,126,1) 0%,rgba(255,255,255,1) 100%);
	background:-webkit-linear-gradient(right,rgba(126,126,126,1) 0%,rgba(255,255,255,1) 100%);
	background:-moz-linear-gradient(right,rgba(126,126,126,1) 0%,rgba(255,255,255,1) 100%);
	background:-ms-linear-gradient(right,rgba(126,126,126,1) 0%,rgba(255,255,255,1) 100%);
	background:linear-gradient(right,rgba(126,126,126,1) 0%,rgba(255,255,255,1) 100%);
	left:0px;
}
.login-button{
    position: absolute;
    top: 50%;
    margin-top: -20px;
    right: -25px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.3);
    width: 50px;
    height: 50px;
    border-radius: 50%;
    line-height: 50px;
    color:#fff;
}
.login-button{
    background-color: #f44336;
    border-color: #f32c1e;
}
.btn-danger:hover {
	color: #fff;
	background-color: #ea1c0d;
	border-color: #c8180b
}
h2.login-check{
    color:#fff;
    font-size: .28rem;
    text-align: center;
    background:#1989fa;
    line-height: 2.5;
    margin:0;
}
</style>